/*
 * DRIVLY-UI React Components
 * @license MIT
 */
function n(n,x){n.min=x.min,n.max=x.max}function x(x,i){n(x.x,i.x),n(x.y,i.y)}export{n as copyAxisInto,x as copyBoxInto};
//# sourceMappingURL=copy.js.map
